import Header from './components/Header';
import Hero from './components/Hero';
import AppSection from './components/AppSection';
import RankingSection from './components/RankingSection';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';
import CarouselSection from './components/CarouselSection';
import UpdatesSection from './components/UpdatesSection';
import TopicsSection from './components/TopicsSection';
import CardsSection from './components/CardsSection';
import MediaSection from './components/MediaSection';
import FaqSection from './components/FaqSection';
import CommentsSection from './components/CommentsSection';
import IndexSection from './components/IndexSection';
import FeaturesSection from './components/FeaturesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <AppSection />
        <RankingSection />
        <AboutSection />
        <ContactSection />
        <CarouselSection />
        <UpdatesSection />
        <TopicsSection />
        <CardsSection />
        <MediaSection />
        <FaqSection />
        <CommentsSection />
        <IndexSection />
        <FeaturesSection />
      </main>
      <Footer />
    </>
  );
}